import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Header } from './components/Layout/Header';
import { Navigation } from './components/Layout/Navigation';
import { Home } from './pages/Home';
import { Menu } from './pages/Menu';
import { Services } from './pages/Services';
import { Experience } from './pages/Experience';
import { Location } from './pages/Location';
import { Covid } from './pages/Covid';
import { Recommend } from './pages/Recommend';
import { Legal } from './pages/Legal';
import { Terms } from './pages/Terms';
import { Share } from './pages/Share';
import { FacialHygiene } from './features/services/FacialHygiene';
import { Rituals } from './features/services/Rituals';
import { GuaSha } from './features/services/GuaSha';
import { Lifting } from './features/services/Lifting';
import { Massage } from './features/services/Massage';
import { Depilation } from './features/services/Depilation';
import { HandsFeet } from './features/services/HandsFeet';

// Loading fallback
const LoadingFallback = () => (
  <div className="w-full h-full flex items-center justify-center">
    <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackNavigation = () => {
    if (['/covid', '/experience', '/location', '/recommend', '/legal', '/terms', '/share'].includes(location.pathname)) {
      navigate('/menu');
    } else if (['/facial-hygiene', '/rituals', '/gua-sha', '/lifting', '/massage', '/depilation', '/hands-feet'].includes(location.pathname)) {
      navigate('/services');
    } else if (location.pathname === '/services') {
      navigate('/menu');
    } else {
      navigate('/');
    }
  };

  const handleMenuClick = () => {
    if (location.pathname === '/menu') {
      navigate('/');
    } else {
      navigate('/menu');
    }
  };

  return (
    <div className="min-h-screen bg-light flex justify-center">
      <div className="w-full max-w-[400px] flex flex-col min-h-screen relative">
        <Header 
          currentSection={location.pathname.slice(1) || 'home'} 
          onBackNavigation={handleBackNavigation} 
        />

        <main className="container mx-auto px-4 pt-20 pb-24">
          <Routes>
            <Route path="/" element={<Home onExperienceClick={(section) => navigate(`/${section}`)} />} />
            <Route path="/menu" element={<Menu onSectionChange={(section) => navigate(`/${section}`)} />} />
            <Route path="/services" element={<Services onServiceClick={(service) => navigate(`/${service}`)} />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/location" element={<Location />} />
            <Route path="/covid" element={<Covid />} />
            <Route path="/recommend" element={<Recommend />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/share" element={<Share />} />
            <Route path="/facial-hygiene" element={<FacialHygiene />} />
            <Route path="/rituals" element={<Rituals />} />
            <Route path="/gua-sha" element={<GuaSha />} />
            <Route path="/lifting" element={<Lifting />} />
            <Route path="/massage" element={<Massage />} />
            <Route path="/depilation" element={<Depilation />} />
            <Route path="/hands-feet" element={<HandsFeet />} />
          </Routes>
        </main>

        <div className="fixed bottom-0 left-0 right-0 flex justify-center">
          <Navigation 
            onHomeClick={() => navigate('/')}
            onMenuClick={handleMenuClick}
            onShareClick={() => navigate('/share')}
          />
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;